export const DEFAULT_DISCOUNT_PERCENTAGE = 10;

export const PAYMENT_DETAILS_STRINGS = {
  TITLE: 'Payment Details',
  AMOUNT: 'Amount',
  STATUS: 'Status',
  PATIENT: 'Patient',
  PAYMENT_METHOD: 'Payment Method',
  INVOICE_NUMBER: 'Invoice Number',
  PAYMENT_INTENT_ID: 'Payment Intent ID',
  BACK: 'Back to Payments',
  NOT_FOUND: 'Payment not found',
  PAYMENT_REFUNDED: 'This payment has been refunded.',
  NOTES: 'Notes (optional)',
  NOTES_PLACEHOLDER: 'Write here any additional information',
  SELECT_REASON: 'Select a reason',
  AMOUNT_TO_REFUND: 'Amount to refund',
  AMOUNT_TO_REFUND_PLACEHOLDER: 'Enter refund amount',
  REFUND_CONFIRMATION_MSG: 'Are you sure you want to refund this payment?',
  REFUND_NOTE:
    'Once confirmed, the charge will be automatically refunded to the patient.This process typically takes 5–10 days.',
  CANCEL: 'Cancel',
  REFUND: 'Refund',
  FINANCIAL_RECORD: 'Financial record',
  TAKE_PAYMENT: 'Take payment',
  SELECT_PAYMENT_METHOD_LABEL: 'Select a payment method',
  PAYMENT_LINK_LABEL: 'Choose an option',
  LOADING_PAYMENT_METHODS: 'Loading...',
  ERROR_LOADING_PAYMENT_METHODS: 'Error loading options',
  CONFIRM_PAYMENT_TITLE: 'Confirm payment',
  CONFIRM_PAYMENT_MESSAGE:
    'Are you sure you want to proceed with taking the payment? Please verify the payment method before confirming.',
  PAYMENT_METHOD_LABEL: 'Payment method',
  CONFIRM: 'Confirm',
  LOADING_REFUND_REASONS: 'Loading refund reasons...',
  PAYMENT_LINK_MODAL_TITLE: 'Payment link',
  PAYMENT_LINK_DESCRIPTION: 'Here is the payment link for this invoice:',
  PAYMENT_LINK_COPY_BUTTON: 'Copy link',
  SEND_VIA_EMAIL: 'Send link via email',
  SEND_VIA_SMS: 'Send link via SMS',
  EMAIL_PLACEHOLDER: 'Enter email address',
  PHONE_PLACEHOLDER: 'Enter phone number',
  SEND_PAYMENT_LINK: 'Send payment link',
  PAYMENT_LINK_COPIED: 'Payment link copied to clipboard',
  PAYMENT_LINK_COPY_ERROR: 'Failed to copy payment link',
  PAYMENT_LINK_SENT_SUCCESS: 'Payment link has been sent successfully',
};

export const refundReasonOptions = [
  {label: 'Choose one option', value: '', disabled: true},
  {label: 'Insurance claim open', value: 'Insurance claim open'},
  {label: 'Duplicate payment', value: 'Duplicate payment'},
  {label: 'Patient cancellation', value: 'Patient cancellation'},
  {label: 'Refund requested by patient', value: 'Refund requested by patient'},
  {label: 'Other', value: 'Other'},
];
